'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

type RenderProps = {
  transactionId?: number
  complaintId?: string | null
}

type Props = {
  children: (props: RenderProps) => JSX.Element
}

// TODO: remove when no more returnable complaints without complaint order items
const ChooseResolutionConversationWrapper = ({ children }: Props) => {
  const { transaction } = useConversationContext()
  const transactionId = transaction?.id
  const complaintId = transaction?.complaintId

  return children({ transactionId, complaintId })
}

export default ChooseResolutionConversationWrapper
